import * as React from 'react';

function Close(props) {
    return React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28 28", className: "c-pieIcon c-pieIcon--Close", width: "1em", height: "1em" }, props),
        React.createElement("path", { d: "M21.4199 22.6625L22.6624 21.42L15.2337 14L22.6624 6.57127L21.4199 5.33752L13.9999 12.7663L6.57115 5.33752L5.3374 6.57127L12.7662 14L5.3374 21.42L6.57115 22.6625L13.9999 15.2338L21.4199 22.6625Z" }));
}

export { Close as default };
